import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import { Router } from '@angular/router';
import {AlertService} from '../../../services/alert.service';
import {ParametrosService} from '../../../services/parametros.service';
import {ComisionesService} from '../../Service/comisiones.service';
import {UserService} from '../../../services/user.service';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';

declare var $: any;
@Component({
    selector: 'app-consultar-cuentas-de-cobro',
    templateUrl: './consultar-cuentas-de-cobro.component.html',
    styleUrls: ['./consultar-cuentas-de-cobro.component.scss'],
    standalone: false
})
export class ConsultarCuentasDeCobroComponent implements OnInit {
  filtrosForm: UntypedFormGroup;
  listaCuentas: any[] = [];
  listaIntermediarios: any[];
  idComision: any;
  fechaActual: string = new Date().toLocaleDateString('en-CA');
  idCliente = this.userIntermediarioService.getUser().idCliente;
  @Input() data: any;
  //Paginación
  totalPaginas: number = 1;
  paginaActual: number = 0;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private comisionService: ComisionesService,
    private alertService: AlertService,
    private parametrosService: ParametrosService,
    private router: Router,
    private userIntermediarioService: UserService,
    private _sweetAlert:SweetAlertService
  ) {
    this.filtrosForm = this.formBuilder.group({
      numeroCuenta: [null],
      estado: [null],
      idCliente: [this.idCliente],
      fechaInicial: [''],
      fechaFinal: [''],
      pagina: [1],
    });
  }

  ngOnInit(): void {
    if (sessionStorage.getItem('filterConsCuenta')) {
      this.filtrosForm.setValue(JSON.parse(sessionStorage.getItem('filterConsCuenta')));
      sessionStorage.removeItem('filterConsCuenta');
    }
    setTimeout(() => {
      $('.selectpicker').selectpicker('refresh');
    },300);
    this.filtrarCuentas();
  }

  isValidFieldConsultaOperacionesForm(field: string) {
    return (
      (this.filtrosForm.get(field)?.dirty ||
        this.filtrosForm.get(field)?.touched) &&
      this.filtrosForm.get(field)?.invalid
    );
  }

  obtenerValorCampo(nombreCampo: string) {
    return this.filtrosForm.get(nombreCampo).value;
  }

  campoContieneValor(nombreCampo: string): boolean {
    if (this.filtrosForm.get(nombreCampo).value) {
      return true;
    } else {
      return false;
    }
  }

  validarFechas() {
    let fechaInicial = new Date();
    let fechaFinal = new Date();
    if (this.campoContieneValor('fechaInicial')) {
      fechaInicial = new Date(this.obtenerValorCampo('fechaInicial'));
    }
    if (this.campoContieneValor('fechaFinal')) {
      fechaFinal = new Date(this.obtenerValorCampo('fechaFinal'));
    }
    if (fechaInicial.getTime() > fechaFinal.getTime()) {
      this.filtrosForm.controls.fechaInicial.setErrors({
        incorrect: true,
      });
    } else {
      this.filtrosForm.controls.fechaInicial.setErrors(null);
      this.filtrosForm.controls.fechaFinal.setErrors(null);
    }
  }

  filtrarCuentas() {
    this.comisionService.consultarCuentasAliado(this.filtrosForm.value).subscribe(
      (response: any) => {
        if (response.data.length === 0){
          this._sweetAlert.errorModal("Error!",true,'No existen registros');
        } else {
          this.listaCuentas = response.data;
          this.totalPaginas = response.paginasTotales;
          this.paginaActual = response.paginaActual;
        }
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,'Error en el servicio');
      }
    );
  }

  saveFilter() {
    sessionStorage.setItem('filterConsCuenta', JSON.stringify(this.filtrosForm.value));
  }

  clear() {
    this.filtrosForm.reset();
    this.filtrosForm.get('pagina').setValue(1);
    this.filtrosForm.get('idCliente').setValue(this.idCliente);
    $('.selectpicker').selectpicker('refresh');
    this.filtrarCuentas();
    sessionStorage.removeItem('filterConsCuenta');
  }

  //Paginación
  selectPage(pageNumber: number){
    this.filtrosForm.get('pagina').setValue(pageNumber);
    this.filtrarCuentas();
  }

  ver(i, estado: any) {
    this.saveFilter();
    this.data = estado;
    this.comisionService.setData(this.data);
    this.idComision = this.listaCuentas[i].idCuentaCobro;
    this.router.navigate([
      'consultar/cuentasDeCobro/ver/' +
      this.idComision,
    ]);
  }

  exportar(esExcel: boolean) {
    const id = this.filtrosForm.get('idCliente').value;
    const est = this.filtrosForm.get('estado').value;
    const cuenta = this.filtrosForm.get('numeroCuenta').value;
    const fechaI = this.filtrosForm.get('fechaInicial').value === '' ? null : this.filtrosForm.get('fechaInicial').value;
    const fechaF = this.filtrosForm.get('fechaFinal').value === '' ? null : this.filtrosForm.get('fechaFinal').value;

    const json = {
      idCliente: this.filtrosForm.get('idCliente').value,
      estado: this.filtrosForm.get('estado').value,
      fechaInicial: this.filtrosForm.get('fechaInicial').value === '' ? null : this.filtrosForm.get('fechaInicial').value,
      fechaFinal: this.filtrosForm.get('fechaFinal').value === '' ? null : this.filtrosForm.get('fechaFinal').value,
      numeroCuentaCobro: this.filtrosForm.get('numeroCuenta').value,
      isExcel: esExcel
    };
    this.comisionService.exportarDocumento(json).subscribe((resp: any) => {
      if (resp.exitoso === true){
        const a = document.getElementById('downloadFile');
        a.setAttribute(
          'href',
          `data:${resp.mimeType};base64,${resp.data}`
        );
        a.setAttribute('download', unescape(resp.fileName));
        a.click();
      } else {
        this._sweetAlert.errorModal("Error!",true,'No fué posible exportar a Excel');
      }
    });
  }

}
